// i18n keys for every column-header decoration LineItemsTable.afterGetColHeader applies.
// Structured as a lookup table (duplicates ok) so a reader can find "column X under context Y"
// without walking a decision tree. Missing branches mean the column does not decorate in that
// combination (e.g. NSP is collapsed away in price-update — no negotiation_starting_price.price_update).
//
// Contexts:
//   - is_required                        → native TH.title, no variants (single string)
//   - <column>.supplierQuote             → info-icon tooltip on the read-only supplier-quote columns
//   - name.itemIntel                     → info-icon tooltip on the Line Item Name column,
//                                          gated by showItemOpportunitiesInEvents at the call site
//   - <column>.nsb_display               → info-icon tooltip on non-split NSB display columns
//                                          (price / nsb_benchmark)
//   - <column>.{rfp,price_update}.<variant>
//                                        → split-layout pricing columns; SP phase 1 renders as
//                                          Hint, phase 0 falls back to info-icon using the same
//                                          tooltip copy
export const HEADER_COPY = {
  discount: {
    supplierQuote: {
      title: 'general.discount_per_unit',
      tooltip: 'line_items.tooltips.supplier_quote_column',
    },
  },
  is_required: {
    title: 'general.required',
  },
  name: {
    itemIntel: {
      title: 'line_items.line_item_name',
      tooltip: 'item_intel.link_info_tooltip',
    },
  },
  negotiation_starting_price: {
    rfp: {
      nsb: {
        hideFromSupplier: true,
        title: 'line_items.negotiation_price',
        tooltip: 'line_items.nsb_negotiation_tooltip_body',
      },
      standard: {
        hideFromSupplier: true,
        title: 'line_items.negotiation_price',
        tooltip: 'line_items.negotiation_price_tooltip',
      },
    },
  },
  nsb_benchmark: {
    nsb_display: {
      title: 'line_items.negotiation_price',
      tooltip: 'line_items.nsb_negotiation_tooltip_body',
    },
  },
  price: {
    nsb_display: {
      title: 'general.baseline_price_per_unit',
      tooltip: 'line_items.nsb_baseline_tooltip_body',
    },
    price_update: {
      nsb: {
        hideFromSupplier: false,
        title: 'general.current_agreed_price_per_unit',
        tooltip: 'line_items.current_agreed_price_tooltip',
      },
      standard: {
        hideFromSupplier: false,
        title: 'general.current_agreed_price_per_unit',
        tooltip: 'line_items.current_agreed_price_tooltip',
      },
    },
    rfp: {
      nsb: {
        hideFromSupplier: true,
        title: 'line_items.reporting_baseline',
        tooltip: 'line_items.nsb_baseline_tooltip_body',
      },
      standard: {
        hideFromSupplier: true,
        title: 'line_items.reporting_baseline',
        tooltip: 'line_items.reporting_price_per_unit_tooltip',
      },
    },
  },
  suggested_price_override: {
    rfp: {
      nsb: {
        hideFromSupplier: false,
        title: 'line_items.suggested_price',
        tooltip: 'line_items.suggested_price_tooltip',
      },
      standard: {
        hideFromSupplier: false,
        title: 'line_items.suggested_price',
        tooltip: 'line_items.suggested_price_tooltip',
      },
    },
  },
  supplier_quantity: {
    supplierQuote: {
      title: 'line_items.quoted_quantity_of_units',
      tooltip: 'line_items.tooltips.supplier_quote_column',
    },
  },
} as const;

export type HeaderCopyEventType = 'price_update' | 'rfp';
export type HeaderCopyVariant = 'nsb' | 'standard';
